<template>
  <div class="setPassword">
    <el-card>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        class="demo-ruleForm"
      >
        <el-form-item class="input_right" label="密码" prop="password">
          <el-input placeholder="请输入密码" v-model="form.password" type="password" />
        </el-form-item>
        <el-form-item class="input_right" label="确认密码" prop="password1">
          <el-input placeholder="请再次输入密码" v-model="form.password1" type="password" />
        </el-form-item>
      </el-form>
      <button @click="searchUser" style="width: 100%;" class="btn_bind">
        设 置 密 码
      </button>
    </el-card>

  </div>
</template>

<script>

  import {setPassWord} from "@/api";
  export default {
    data() {
      return {
        rules: {
          password1: [
            {
              required: true, message: '请再次输入密码'
            },
            {min: 6, message: '至少6位', trigger: 'blur'},
            {max: 8, message: '最多8位', trigger: 'blur'},
          ],
          password: [
            {
              required: true, message: '请输入密码',
            },
            {min: 6, message: '至少6位', trigger: 'blur'},
            {max: 8, message: '最多8位', trigger: 'blur'},
          ],
        },
        form: {},
      }
    },
    mounted() {

    },
    methods: {
      searchUser() {
        if(this.form.password!=this.form.password1) {
          this.$toast('两次密码不一致')
          return
        }
        let params = {
          companyCode: sessionStorage.getItem('companyCode'),
          customerId: this.$route.query.userId,
          passWord: this.form.password
        }
        setPassWord(params).then(res=>{
          if(res.code=='0000') {
            this.$toast('设置成功')
            this.$router.go(-1)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .setPassword{
    height: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/view/fzxx/setPassword/setPassword.vue